define.alias("shared/components/shared/credentials/tiktok-refresh", "calendar/components/shared/credentials/tiktok-refresh");